/***********************************************************
Royal Hawaiian Services
Alexander Self
2/6/18
11.15.22: Update; create multiple input dynamic harvest form
Mech. harvest form: Handles form interactions
***********************************************************/
import React, { Component } from 'react';
import moment from 'moment';
import {
  TextInput, 
  NumberInput, 
  Select, 
  SelectField, 
  SelectBlock, 
  AutoComplete,
  DatePicker2 
} from '../../inputs';
import { 
  LOCATIONS, 
  CONTAINER_TYPES, 
  STATUS 
} from '../../../constants';
import { 
  mapEquipmentForAutoComplete, 
  onDummyComplete,
  mapEmployeeForAutoComplete 
} from '../../../utils';

class MechanicalHarvestForm2 extends Component {
  render() {
    return (
      <div className="pl-2 pr-2 pt-2 pb-2">
        <form id="mechHarvest-form" onSubmit={(e) => e.preventDefault()}>
          <div className="row">
            <div className="col s12 m6 l3 xl3">
              <DatePicker2 
                id={'mech-date'} 
                label={'Date'}
                defaultValue={moment().format('YYYY-MM-DD')} 
                max={moment().format('YYYY-MM-DD')} 
              />
            </div>
            <div className="col s12 m6 l3 xl3">
              <Select 
                id={'mech-location'} 
                opts={LOCATIONS} 
                label={'Location'} 
                onChange={(e) => this.props.fetchFieldsByLoc(e.target.value)} 
              />
            </div>
            <div className="col s12 m6 l3 xl3">
              <NumberInput 
                id={'mech-round'} 
                label={'Round'}
                min={1}
                max={5} 
              />
            </div>
            <div className="col s12 m6 l3 xl3">
              <TextInput
                id={'mech-notes'} 
                label={'Notes'} 
              />
            </div>
          </div>
          </form>
          
          <p className="ml-1 flow-text"><u>Individual Harvest</u></p>
         
          <form id="mechHarvest-individual-form" onSubmit={(e) => e.preventDefault()}>
            <div className="row">
              <div className="col s12 m6 l3 xl3">
                <SelectField 
                  id={'mech-field'} 
                  opts={this.props.fields} 
                  label={'Field'}
                  onChange={(event) => { 
                    this.props.fetchBlocksByField(
                      event.target.value, 
                      'mech-field'
                    ); 
                    this.props.selectField(event.target.value) 
                  }} 
                />
              </div>
              <div className="col s12 m6 l3 xl3">
                <SelectBlock 
                  id={'mech-block'} 
                  label={'Block No.'} 
                  opts={this.props.blocks} 
                />
              </div>
              <div className="col s12 m6 l3 xl3">
                <NumberInput 
                  id={'mech-treesCovered'} 
                  label={'Trees Covered'} 
                />
              </div>
              <div className="col s12 m6 l3 xl3">
                <NumberInput 
                  id={'mech-hours'} 
                  label={'Total Hours'} 
                  step={"0.1"} 
                />
              </div>
            </div>
            <div className="row">
              <div className="col s12 m6 l3 xl3">
                <Select 
                  id={'mech-containerType'} 
                  opts={CONTAINER_TYPES} 
                  label={'Container Type'} 
                />
              </div>
              <div className="col s12 m6 l3 xl3">
                <NumberInput 
                  id={'mech-containerCount'} 
                  label={'Total Containers'} 
                />
              </div>
              <div className="col s12 m6 l3 xl3">
                <NumberInput 
                  id={'mech-estLbsPerContainer'} 
                  label={'Est. Lbs/Container'} 
                />
              </div>
              <div className="col s12 m6 l3 xl3">
                <Select id={'mech-status'} opts={STATUS} label={'Status'} />
              </div>
            </div>
            <div className="row">
              <div className="col s12 m6 l4 xl4">
                <AutoComplete 
                  id={'mech-equipmentNo'} 
                  label={'Equipment No.'}
                  data={mapEquipmentForAutoComplete(this.props.equipmentNo)} 
                  onComplete={onDummyComplete}  
                />
              </div>
              <div className="col s12 m6 l4 xl4">
                <AutoComplete 
                  id={'mech-eid'} 
                  label={'Equipment Operator'}
                  data={mapEmployeeForAutoComplete(this.props.employees)}
                  onComplete={onDummyComplete}  
                />
              </div>
              <div className="col s12 m6 l4 xl4 mt-2">
                <div className="pt-2">
                  {
                    this.props.toEdit ?
                    <button 
                      className="btn waves-effect waves-light blue"
                      onClick={this.props.editHarvestRecord}>
                      Edit Harvest
                    </button>
                  : <button 
                      className="btn waves-effect waves-light"
                      onClick={this.props.addHarvestRecord}>
                      Add Harvest
                    </button>
                  }
                </div>
                
              </div>
            </div>
            <input type="hidden" id="mech-time" value={moment().format("hh:mm:ss a")} />
            <input type="hidden" id="mech-submitter" value={this.props.submitter} />
          </form>  
      </div>
    )
  }
}

export default MechanicalHarvestForm2;

/*

*/


/* END */



// WEBPACK FOOTER //
// ./src/components/harvest/create/mechHarvest_form_2.jsx